import React from 'react';
import sortBy from 'lodash/sortBy';
import styled from 'styled-components';

import { navigation } from '@shared/constants/navigate';
import { NavItem } from '@components/atoms';

type NavigateProps = {
  ariaLabel: string;
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  direction?: 'column';
};

function Navigate({ onLinkClick, ariaLabel, direction }: NavigateProps) {
  return (
    <StyledNav aria-label={ariaLabel}>
      <StyledUl $direction={direction}>
        {sortBy(navigation, 'sortOrder').map(({ title, href }) => (
          <NavItem
            href={href}
            onLinkClick={onLinkClick}
            title={title}
            key={href}
          />
        ))}
      </StyledUl>
    </StyledNav>
  );
}

const StyledUl = styled.ul<{ $direction?: string }>`
  display: flex;
  align-items: center;

  flex-direction: ${({ $direction }) => $direction};
`;

const StyledNav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Navigate;
